import React from 'react';
import { oneOfType, string, bool, object, array } from 'prop-types';
import { get } from 'lodash';
import { FlexContainer, Row, Column, Icon, Text, Image, Number } from '../../common';
import { CULTURED, GRAY_DARK, GREEN_DARK, WHITE } from '../../../utils/colors';
import { quantityRenderer } from '../../../utils/misc';

const CustomerSelection = ({ itemOriginal, substitution }) => {
    const itemOriginalBrandName = get(itemOriginal, 'brandName', 'Sin Marca');
    const itemOriginalName = get(itemOriginal, 'name', 'Sin nombre');
    const itemOriginalQuantity = get(itemOriginal, 'quantity', 1);


    if (typeof substitution === 'boolean') {
        return (
            <FlexContainer>
                <Text size={10} text='El cliente &nbsp;' />
                <Text size={10} strong text='NO quiere reemplazo' />
                <Text size={10} text='&nbsp;para&nbsp;' />
                <Text size={10} strong color={GRAY_DARK} text={`${itemOriginalBrandName} ${itemOriginalName}`} />
            </FlexContainer>
        );
    };

    if (typeof substitution === 'string') {
        return (
            <FlexContainer>
                <Text size={10} text='El cliente quiere sustituir &nbsp;' />
                <Text size={10} strong color={GRAY_DARK} text={`${itemOriginalBrandName} ${itemOriginalName}`} />
                <Text size={10} text='&nbsp;por&nbsp;' />
                <Text size={10} strong text={substitution} />
            </FlexContainer>
        );
    };

    return (
        <FlexContainer direction='column'>
            <Row>
                <Text size={10} text='El cliente ha seleccionado lo siguiente:' />
            </Row>
            <Row>
                <Column>
                    <FlexContainer direction='column'>
                        <Row mT={8} padding={8} align='center'>
                            <Column align='center'>
                                <Text size={10} text='Original' color={GRAY_DARK} strong />
                                <FlexContainer padding={8} backgroundColor={CULTURED} borderRadius={8} margin={8} direction='column' align='center'>
                                    <Image src={get(itemOriginal, 'image')} maxHeight={51} maxWidth={51} />
                                    <Text size={10} text={itemOriginalBrandName} strong nowrap paddingTop={8} />
                                    <Text text={get(itemOriginal, 'name', 'Producto desconocido')} size={10} nowrap />
                                    <Text size={10} text={`Unidades: ${itemOriginalQuantity}`} strong nowrap />
                                    <FlexContainer>
                                        <Text size={10} allowWhiteSpace text={`P. ${quantityRenderer(itemOriginalQuantity, 'Uni', 'Total')} `} color={GREEN_DARK} />
                                        <Text size={10} text={<Number isPrice value={get(itemOriginal, 'price', 0)} />} color={GREEN_DARK} strong />
                                    </FlexContainer>
                                </FlexContainer>
                            </Column>
                            <Column justify='center'>
                                <Icon name='substitution' size={19} color={GREEN_DARK} />
                            </Column>
                            <Column align='center'>
                                <Text size={10} text='Sustituto' strong />
                                <FlexContainer padding={8} backgroundColor={WHITE} borderRadius={8} margin={8} direction='column' align='center'>
                                    <Image src={get(substitution, 'image')} maxHeight={69} maxWidth={69} />
                                    <Text size={10} text={get(substitution, 'brandName', 'Sin Marca')} strong nowrap paddingTop={8} />
                                    <Text text={get(substitution, 'name', 'Producto desconocido')} size={10} nowrap />
                                    <Text size={10} text={`Unidades: ${itemOriginalQuantity}`} strong nowrap />
                                    <FlexContainer>
                                        <Text size={10} allowWhiteSpace text={`P. ${quantityRenderer(itemOriginalQuantity, 'Uni', 'Total')} `} color={GREEN_DARK} />
                                        <Text size={10} text={<Number isPrice value={get(substitution, 'price', 0) * get(substitution, 'quantity', 0)} />} color={GREEN_DARK} strong />
                                    </FlexContainer>
                                </FlexContainer>
                            </Column>
                        </Row>
                    </FlexContainer>
                </Column>
            </Row>
        </FlexContainer>
    );
};

CustomerSelection.propTypes = {
    itemOriginal: oneOfType([object, array]),
    substitution: oneOfType([object, string])
};

CustomerSelection.propTypes = {
    itemOriginal: {},
    substitution: null
};

export default CustomerSelection;